import React from 'react';

const THEMES = {
  blue:   { gradient: 'from-blue-500 to-blue-700',   icon: 'bg-blue-400/20',   text: 'text-blue-100',  sub: 'text-blue-200' },
  green:  { gradient: 'from-emerald-500 to-emerald-700', icon: 'bg-emerald-400/20', text: 'text-emerald-100', sub: 'text-emerald-200' },
  orange: { gradient: 'from-orange-500 to-orange-700', icon: 'bg-orange-400/20', text: 'text-orange-100', sub: 'text-orange-200' },
  purple: { gradient: 'from-violet-500 to-violet-700', icon: 'bg-violet-400/20', text: 'text-violet-100', sub: 'text-violet-200' },
  red:    { gradient: 'from-rose-500 to-rose-700',    icon: 'bg-rose-400/20',   text: 'text-rose-100',  sub: 'text-rose-200' },
  cyan:   { gradient: 'from-cyan-500 to-cyan-700',    icon: 'bg-cyan-400/20',   text: 'text-cyan-100',  sub: 'text-cyan-200' },
};

const StatCard = ({ title, value, icon, color = 'blue', subtitle, trend }) => {
  const theme = THEMES[color] || THEMES.blue;

  return (
    <div className={`relative rounded-2xl bg-gradient-to-br ${theme.gradient} p-5 text-white shadow-lg overflow-hidden`} dir="rtl">
      {/* Background decoration */}
      <div className="absolute -left-4 -bottom-4 w-24 h-24 rounded-full bg-white/5" />
      <div className="absolute -left-2 -bottom-8 w-32 h-32 rounded-full bg-white/5" />

      <div className="relative">
        <div className="flex items-start justify-between mb-4">
          <div className={`w-11 h-11 rounded-xl ${theme.icon} flex items-center justify-center text-2xl backdrop-blur-sm`}>
            {icon}
          </div>
          {trend !== undefined && (
            <div className={`flex items-center gap-1 text-xs font-medium px-2 py-1 rounded-full ${trend >= 0 ? 'bg-white/20 text-white' : 'bg-red-400/30 text-red-100'}`}>
              <span>{trend >= 0 ? '↑' : '↓'}</span>
              <span>{Math.abs(trend)}%</span>
            </div>
          )}
        </div>

        <div>
          <p className={`text-sm font-medium mb-1 ${theme.text}`}>{title}</p>
          <p className="text-3xl font-bold leading-none">{value}</p>
          {subtitle && (
            <p className={`text-xs mt-2 ${theme.sub}`}>{subtitle}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default StatCard;
